import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class ClientConditionCodeDto extends BaseEntityDto {
  code: string;

  days: number;

  toString() {
    return this.code;
  }
}
